import { useQuery } from 'react-query';

import { useServiceError } from '@/hooks';

import { listTaxRegimes } from './TaxRegime.service';

export function useTaxRegimes() {
  const query = useQuery(['taxRegimes'], () => listTaxRegimes());

  useServiceError(query.error);

  return query;
}
